import React from "react";
import TableHeader from "../Recruit/RecJobs/SubComponents/components/TableHeader";
import VehicleBrandTableBody from "./VehicleBrandTableBody";
import Pagination from "../Recruit/RecJobs/SubComponents/components/Pagination";
import { useTableSort } from "../Recruit/RecJobs/SubComponents/hooks/useTableSort";

const VehicleBrandTableDiff = ({
  headers,
  data,
  rowKey,
  defaultSortKey,
  tableClassName = "",
  headerClassName = "",
  rowClassName = "",
  tableActions,
  onPageChange,
  onPerPageChange,
  queries,
  tableStyle,
}) => {
  const { sortedData, sortConfig, handleSort } = useTableSort(
    data,
    defaultSortKey
  );

  const { dropdownIndex, toggleDropdown, handleActionClick } = tableActions;

  // Handle pagination actions
  const handleActionPerPage = (newPerPage) => {
    if (onPerPageChange) onPerPageChange(newPerPage);
  };

  const handleActionPage = (newPage) => {
    if (onPageChange) onPageChange(newPage);
  };

  return (
    <div className="w-full p-4 text-black font-Ubuntu">
      <div className="bg-white p-4 rounded-t-md shadow-lg">
        <table className={`w-full ${tableClassName}`}>
          <TableHeader
            headers={headers}
            sortConfig={sortConfig}
            onSort={handleSort}
            headerClassName={headerClassName}
            tableStyle={tableStyle}
          />
          <VehicleBrandTableBody
            data={sortedData}
            headers={headers}
            rowKey={rowKey}
            dropdownIndex={dropdownIndex}
            toggleDropdown={toggleDropdown}
            onActionClick={handleActionClick}
            rowClassName={rowClassName}
            tableStyle={tableStyle}
          />
        </table>
      </div>

      <Pagination
        queries={queries}
        onPageChange={handleActionPage}
        onPerPageChange={handleActionPerPage}
      />
    </div>
  );
};

export default VehicleBrandTableDiff;
